import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import CampaignsEditForm from './CampaignsEditForm';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { fetchCampaign } from 'store/actions/campaigns/fetchCampaigns';
import { updateCampaign } from 'store/actions/campaigns/updateCampaigns';

class CampaignsEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        return new Promise((resolve, reject) => {
            dispatchForm({
                callback: () => {
                    // This location should have where we bounce the error back to the form with SubmissionError.
                    reject();
                },
                onSuccess: () => {
                    resolve(history.push(`/campaigns/${ id }/show`));
                },
                values: values,
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.campaigns.title'),
                link: '/campaigns',
            },
            {
                label: data.name,
                link: `/campaigns/${ data.id }/show`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.campaigns.actions.edit', { title: data.name }) } />

                    <Actions>
                        <ListButton url='/campaigns' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <CampaignsEditForm
                            data={ data }
                            form='campaigns_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

CampaignsEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateCampaign(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
    fetchResourceById({
        action: fetchCampaign,
        resource: 'campaigns',
    })
);

export default enhance(CampaignsEditContainer);



// WEBPACK FOOTER //
// ./src/pages/campaigns/edit/CampaignsEditContainer.js